<div
  *ngIf="!loading"
  class="px-3 pt-6 pb-7">
  <p class="font-medium text-2xl">Укажите ИНН вашей компании</p>

  <div class="mt-5 text-left">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">ИНН</label>
        <crm-inn-auto-complete
          [(selectedPerson)]="person"
          (selectedPersonChange)="selectedPerson($event)"
          [persons]="persons"
          (personSearch)="searchParson($event)"
          [isError]="!!errors"
          [autofocus]="true"
          appendTo="body"></crm-inn-auto-complete>
        <small
          *ngIf="errors"
          class="p-error">
          {{ errors }}
        </small>
      </div>
    </div>
  </div>

  <div class="flex justify-content-center mt-5">
    <button
      pButton
      type="button"
      label="Далее"
      icon="pi pi-arrow-right"
      iconPos="right"
      class="p-button-success p-button-lg"
      (click)="create()"></button>
  </div>
</div>

<crm-spinner
  *ngIf="loading"
  top="mt-4"></crm-spinner>
